/** @jsxImportSource @emotion/react */
"use client";

import type { Interpolation } from "@emotion/react";
import type { ReactElement } from "react";

import type { ThemeType } from "../../../../../global/emotion";
import type { CardProps } from "../../../refactor/Card/Card.emotion";
import { Card } from "../../../refactor/Card/Card.emotion";

const cssCard: Interpolation = {
  paddingBottom: "90px",
};
const infoContainerCSS: Interpolation<ThemeType> = (theme) => ({
  paddingLeft: theme.spacing.m,
  paddingRight: theme.spacing.m,
});

export type CategoriesGameMediumProps = Omit<CardProps, "content"> & {
  content?: ReactElement | null;
};

export const CategoriesGameMedium = ({
  color = "black",
  content,
  imgSrc,
  ...props
}: CategoriesGameMediumProps) => (
  <Card
    css={cssCard}
    color={color}
    imgSrc={imgSrc}
    infoContainerCSS={infoContainerCSS}
    overlay={content}
    {...props}
  />
);
